export { fechaCorta, fechaHoraLocal, mxn } from '@plataforma/web/formato';

export const ETIQUETAS_ESTADO: Record<string, string> = {
  lote_en_subasta: 'Vigilado en subasta',
  comprado: 'Comprado',
  transito_aduana: 'En tránsito o aduana',
  recibido: 'Recibido',
  en_reparacion: 'En taller',
  listo: 'Listo',
  en_preparacion: 'En preparación',
  publicado: 'Publicado',
  vendido: 'Vendido',
  en_desarme: 'En desarme',
  desarmado: 'Desarmado',
  chatarra: 'Chatarra',
};

export const ETAPAS_COSTO: Record<string, string> = {
  adquisicion: 'Adquisición',
  traslado: 'Traslado',
  tramites_eeuu: 'Trámites en EE. UU.',
  importacion: 'Importación',
  reparacion: 'Reparación',
  preparacion: 'Preparación y trámites',
  desarme: 'Desarme',
  venta: 'Venta',
};

/** Ruta y situación legal del vehículo (arquitectura 2.15). */
export const ETIQUETAS_RUTA: Record<string, string> = {
  mexico: 'Importar a México',
  eeuu: 'Se queda en EE. UU.',
  deshuesar: 'Solo partes',
};
export const ETIQUETAS_SITUACION: Record<string, string> = {
  por_definir: 'Por definir',
  titulo_eeuu: 'Título de EE. UU.',
  circulacion_temporal: 'Circulación temporal en EE. UU.',
  en_importacion: 'En importación',
  importado_pedimento: 'Importado con pedimento',
  regularizado_decreto: 'Regularizado por decreto',
  nacional: 'Nacional',
  partes: 'Solo partes',
};
/** Nombres legibles de los catálogos del lote (claves de la API de Abastecimiento). */
export const ETIQUETAS_LOTE: Record<string, string> = {
  clean: 'Clean',
  salvage: 'Salvage',
  rebuilt: 'Rebuilt',
  non_repairable: 'Non-repairable',
  junk: 'Junk',
  certificate_of_destruction: 'Certificate of destruction',
  desconocido: 'Sin capturar',
  run_and_drive: 'Run and Drive',
  start: 'Start',
  no_start: 'No Start',
  front_end: 'Frontal',
  side: 'Lateral',
  rear: 'Trasero',
  hail: 'Granizo',
  mechanical: 'Mecánico',
  flood: 'Inundación',
  fire: 'Fuego',
  vandalism: 'Vandalismo',
  rollover: 'Volcadura',
  undercarriage: 'Bajos',
  all_over: 'Por todos lados',
  minor_dents: 'Golpes menores',
  normal_wear: 'Desgaste normal',
  ninguno: 'Sin daño',
  otro: 'Otro',
  pure_sale: 'Pure Sale',
  on_minimum_bid: 'On Minimum Bid',
  on_approval: 'On Approval',
  transferencia: 'Transferencia',
  cheque_caja: 'Cheque de caja',
  efectivo: 'Efectivo',
  broker: 'Por medio del broker',
  subasta: 'Subasta',
  facebook_marketplace: 'Facebook Marketplace',
  dealer: 'Dealer',
  particular: 'Particular',
  ebay_motors: 'eBay Motors',
  limpio: 'Limpio',
  robo: 'Reporte de robo',
  inundacion: 'Inundación',
  perdida_total: 'Pérdida total',
  odometro: 'Odómetro alterado',
  nmvtis: 'NMVTIS',
  carfax: 'Carfax',
  autocheck: 'AutoCheck',
  repuve: 'REPUVE',
  otra: 'Otra fuente',
  ia_fotos: 'IA por fotos',
  dtc: 'Códigos DTC',
  taller: 'Taller',
  proveedor: 'Proveedor',
  manual: 'A mano',
  frontera: 'Región fronteriza',
  resto: 'Resto del país',
  viable: 'Viable',
  revisar: 'Revisar',
  no_viable: 'No viable',
};
export const etiqueta = (clave: string | null | undefined) =>
  clave ? (ETIQUETAS_LOTE[clave] ?? clave) : '—';

/** Nombre corto de un vehículo: año, marca, modelo y versión. */
export const nombreVehiculo = (v: {
  anio: number | null;
  marca: string | null;
  modelo: string | null;
  version: string | null;
}) =>
  [v.anio, v.marca, v.modelo, v.version].filter(Boolean).join(' ') || 'Vehículo sin decodificar';
